import {Ban} from 'lucide-react';
import {createLucideIcon} from '../create-lucide-icon';

export const DangerousIcon = createLucideIcon(Ban, 'DangerousIcon');
